module.exports = require("strip-json-comments");


//////////////////
// WEBPACK FOOTER
// external "strip-json-comments"
// module id = 136
// module chunks = 0